import { useEffect, useState, useCallback } from "react";

const KEY = "animaux_cart_v1";

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

const write = (items) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent("cart:update"));
  } catch {}
};

export function useCart() {
  const [items, setItems] = useState(read);

  useEffect(() => {
    const sync = () => setItems(read());
    window.addEventListener("cart:update", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("cart:update", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const addItem = useCallback((item) => {
    const list = read();
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
    list.push({ ...item, id, qty: item.qty || 1 });
    write(list);
  }, []);

  const removeItem = useCallback((id) => {
    write(read().filter((i) => i.id !== id));
  }, []);

  const updateQty = useCallback((id, qty) => {
    if (qty < 1) return;
    write(read().map((i) => (i.id === id ? { ...i, qty } : i)));
  }, []);

  const clear = useCallback(() => write([]), []);

  const totalCount = items.reduce((acc, i) => acc + i.qty, 0);

  const subtotal = items.reduce((acc, i) => acc + i.unitPrice * i.qty, 0);

  // Same volume discount as before, applied to TOTAL units across cart
  const discount = totalCount === 2 ? 0.15 : totalCount >= 3 ? 0.20 : 0;
  const total = subtotal * (1 - discount);

  return { items, addItem, removeItem, updateQty, clear, totalCount, subtotal, total, discount };
}

export function getCartCount() {
  return read().reduce((a, i) => a + (i.qty || 0), 0);
}
